import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostCreateDocument extends ResponseREST {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
}

export const deleteRemoveDocument = async (
  id: number
): Promise<ResponseSuccessPostCreateDocument> => {
  return axiosInstance
    .delete('api/stock-waste-document-mobile/remove-stock-waste/' + id)
    .then((res: AxiosResponse<ResponseSuccessPostCreateDocument>) => res.data)
    .catch((err) => err);
};
